<template>
  <div>
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
      >
        返回
      </el-button>
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/list-query/item-list' }"
          >功能样例</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path:
              $store.getters.getBreadcrumb('level2').path ||
              '/list-query/peoplemanage/item-list-all'
          }"
          >{{
            $store.getters.getBreadcrumb("level2").name ||
              "主子表增删改查(多页签)"
          }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          <span class="ccui-curr-crumb">新增人员</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container-detail-body">
        <el-group-title title="基本信息">
          <template slot="groupTitle">
            <el-form
              :model="form"
              :rules="rules"
              ref="form1"
              label-width="160px"
              class="ccui-form"
              style="overflow:visible;"
            >
              <el-form-item label="姓名：" prop="userName">
                <el-input
                  v-model="form.userName"
                  class="ccui-form-shortInput"
                  placeholder="请输入姓名"
                  clearable
                  maxlength="15"
                />
              </el-form-item>
              <el-form-item label="性别：" prop="sex">
                <el-radio-group v-model="form.sex">
                  <el-radio label="1">男</el-radio>
                  <el-radio label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="出生日期：" prop="birthday">
                <el-date-picker
                  type="date"
                  placeholder="请选择出生日期"
                  v-model="form.birthday"
                  style="width:160px"
                  clearable
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="年龄：" prop="age">
                <el-input
                  v-model.trim="form.age"
                  class="ccui-form-shortInput"
                  placeholder="请输入年龄"
                  clearable
                  maxlength="3"
                />
              </el-form-item>
              <el-form-item label="政治面貌：" prop="politicalOutlook">
                <el-select
                  v-model="form.politicalOutlook"
                  class="ccui-form-shortInput"
                  placeholder="请选择"
                  value
                >
                  <el-option label="群众" value="1"></el-option>
                  <el-option label="团员" value="2"></el-option>
                  <el-option label="党员" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="婚姻状况：" prop="isMarried">
                <el-radio-group v-model="form.isMarried">
                  <el-radio label="1">未婚</el-radio>
                  <el-radio label="2">已婚</el-radio>
                  <el-radio label="3">离异</el-radio>
                  <el-radio label="4">丧偶</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="籍贯：" prop="nativeplace">
                <el-cascader
                  ref="myCascader"
                  popper-class="popperClass"
                  :props="propsPlace"
                  v-model="valuePlace"
                  @change="handleChange"
                  style="width:260px"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="毕业院校：" prop="finishSchool">
                <el-input
                  v-model.trim="form.finishSchool"
                  class="ccui-form-longInput"
                  placeholder="请输入毕业院校"
                  clearable
                  maxLength="100"
                />
              </el-form-item>
              <el-form-item label="护照号：" prop="passportNo">
                <el-input
                  type="text"
                  placeholder="请输入护照号"
                  v-model="form.passportNo"
                  @input="
                    value => {
                      form.passportNo = value.replace(/[^\dA-Za-z]/g, '');
                    }
                  "
                  maxlength="9"
                  class="ccui-form-shortInput"
                  clearable
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号：" prop="idNum">
                <el-input
                  type="text"
                  placeholder="请输入身份证号"
                  v-model="form.idNum"
                  @input="
                    value => {
                      form.idNum = value.replace(/[^\dXx]/g, '');
                    }
                  "
                  maxlength="18"
                  class="ccui-form-longInput"
                  clearable
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证附件：" class="ccui-form-shenfenzheng">
                <div class="el-upload__top">
                  只能上传jpg/png文件，且不超过2MB
                </div>
                <div style="height:168px; width:258px; float:left">
                  <el-upload
                    class="avatar-uploader avatar-uploader-shenfenzheng"
                    :show-file-list="false"
                    :action="uploadUrl"
                    :before-upload="uploadBeforeAvatar"
                    :file-list="fileList"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :headers="headers"
                  >
                    <div v-if="form.imageUrl">
                      <img
                        style="width:258px;height:168px"
                        :src="form.imageUrl"
                        class="avatar"
                      />
                    </div>
                    <i
                      v-if="!loading && !form.imageUrl"
                      class="el-icon-plus avatar-uploader-icon"
                    >
                      <p>身份证正面照片</p>
                    </i>
                    <div
                      v-if="loading"
                      style="width:258px;height:168px;line-height:168px;"
                      class="ccui-form-loadingMask"
                    >
                      <img
                        src="data:image/gif;base64,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"
                        alt=""
                      />
                    </div>
                  </el-upload>
                </div>
                <div
                  style="height:168px;width:258px; float:left; margin-left:20px"
                >
                  <el-upload
                    class="avatar-uploader avatar-uploader-shenfenzheng"
                    :show-file-list="false"
                    :action="uploadUrl"
                    :on-success="handleSuccess1"
                    :on-error="handleError1"
                    :before-upload="uploadBeforeAvatar1"
                    :file-list="fileList"
                    :headers="headers"
                  >
                    <!-- :http-request="handleUploadForm2" -->
                    <!-- :on-progress="onProgress1" -->
                    <div v-if="form.imageUrl2">
                      <img
                        style="width:258px;height:168px"
                        :src="form.imageUrl2"
                        class="avatar"
                      />
                    </div>
                    <i
                      v-if="!loading1 && !form.imageUrl2"
                      class="el-icon-plus avatar-uploader-icon"
                    >
                      <p>身份证反面照片</p>
                    </i>
                    <div
                      v-if="loading1"
                      style="width:258px;height:168px;line-height:168px;"
                      class="ccui-form-loadingMask"
                    >
                      <img
                        src="data:image/gif;base64,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"
                        alt=""
                      />
                      <!-- <p class="el-loading-text">上传中，请稍等...</p> -->
                    </div>
                  </el-upload>
                </div>
              </el-form-item>
              <el-form-item label="手机号：" prop="userMobile">
                <el-input
                  type="text"
                  placeholder="请选择"
                  v-model="form.userMobile"
                  @input="
                    value => {
                      form.userMobile = value.replace(/[^\d]/g, '');
                    }
                  "
                  maxlength="11"
                  class="ccui-form-longInput"
                  show-word-limit
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="兴趣爱好：" prop="hobby">
                <el-checkbox-group v-model="hobbyList">
                  <el-checkbox
                    :label="item.label"
                    :value="item.value"
                    v-for="(item, index) in hobbyListArray"
                    :key="index"
                  >
                    {{ item.value }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="选择配送区域：" prop="address1">
                <span v-for="(item, index) in addressList1" :key="index">{{
                  index + 1 == addressList1.length
                    ? `${item.cityName}`
                    : `${item.cityName}，`
                }}</span>
                <el-button
                  plain
                  type="single-number"
                  style="margin-left:10px;"
                  @click="selectAddress1"
                >
                  选择地址
                </el-button>
                <!-- 选择地址 -->
                <el-region-selector
                  :dialogVisible.sync="addressShow"
                  :checkedCitiesa="addressList1"
                  :url="url"
                  :agentId="paramsData"
                  @myCancel="getMyCancel"
                  title="选择配送区域"
                  :headers="headers"
                />
              </el-form-item>
              <el-form-item label="选择地址2：" prop="address2">
                <el-area-selector
                  :defaultArea="defaultArea"
                  @getAddressOf="getAddressOf"
                  :place="leftPlace"
                  :url="url"
                  :agentId="paramsData"
                  :headers="headers"
                ></el-area-selector>
              </el-form-item>
            </el-form>
          </template>
        </el-group-title>
        <!-- <div class="ccui-top-title">基本信息</div> -->
        <el-group-title title="岗位信息">
          <template slot="groupTitle">
            <el-form
              :model="form"
              :rules="rules"
              ref="form2"
              label-width="160px"
              class="ccui-form"
              style="overflow:visible;"
            >
              <el-form-item label="所在部门：" prop="departmentId">
                <div class="ccui-form-choseContent">
                  <span v-for="(item, index) in form.choseCheck" :key="index">
                    <span class="abbrName" :title="item.abbrName">
                      {{ item.abbrName }}
                      <span
                        class="el-icon-close close"
                        style="color:#999999;"
                        @click="deleteClass(index)"
                      ></span>
                    </span>
                  </span>
                  <el-button
                    plain
                    type="single-number"
                    style="margin-left:10px;"
                    @click="handleShows"
                  >
                    选择
                  </el-button>
                </div>
              </el-form-item>
              <el-form-item label="工作状态：" prop="workStatus">
                <el-radio-group v-model="form.workStatus">
                  <el-radio label="1">在职在岗</el-radio>
                  <el-radio label="2">在职离岗</el-radio>
                  <el-radio label="3">离职离岗</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否在编：">
                <el-switch
                  v-model="form.isPrep"
                  active-text="是"
                  inactive-text="否"
                  :active-value="1"
                  :inactive-value="0"
                  width="50"
                  class="ccui-form-switch"
                ></el-switch>
              </el-form-item>
            </el-form>
          </template>
        </el-group-title>
        <!-- <div class="ccui-top-title" style="margin:10px 0;">岗位信息</div> -->
        <el-group-title class="ccui-group-wrapper" title="工作经历">
          <template slot="groupTitle">
            <el-form
              :model="form"
              :rules="rules"
              ref="form3"
              label-width="160px"
              class="ccui-form"
              style="overflow:visible;"
            >
              <div class="extend-btn">
                <el-button plain type="single-number" @click="addTable">
                  新增
                </el-button>
              </div>
              <el-table
                :data="tableData"
                style="margin-bottom:20px;width:100%;"
                class="ccui-multifunctional-table ccui-form-table"
                border
              >
                <el-table-column
                  :show-overflow-tooltip="true"
                  label="序号"
                  type="index"
                  align="center"
                />
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="value1"
                  label="起止日期"
                  min-width="100%"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      v-model="scope.row.value1"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      clearable
                    ></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="company"
                  label="单位"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.company"
                      placeholder="请输入"
                      clearable
                      maxlength="250"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="position"
                  label="岗位"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.position"
                      placeholder="请输入"
                      clearable
                      maxlength="250"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="occupation"
                  label="职务"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.occupation"
                      placeholder="请输入"
                      clearable
                      maxlength="250"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="salary"
                  label="薪资(元/月)"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-input
                      placeholder="请输入金额"
                      v-model="scope.row.salary"
                      @blur="handleSalary"
                      clearable
                      maxLength="11"
                      ><span
                        slot="prefix"
                        style="color:#4A4A4A;line-height: 31px"
                        >¥</span
                      ></el-input
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="scaleNum"
                  label="操作"
                  align="center"
                  width="100%"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="delTable(scope.$index, scope.row)"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </template>
        </el-group-title>
        <el-group-title title="奖惩情况" style="padding-bottom:30px;">
          <template slot="groupTitle">
            <el-form
              :model="form"
              :rules="rules"
              ref="form4"
              label-width="160px"
              class="ccui-form"
              style="overflow:visible;"
            >
              <el-form-item
                label="奖惩情况："
                prop="bonusPenalty"
                class="ccui-form-textArea"
              >
                <el-input
                  type="textarea"
                  placeholder="请输入奖惩情况"
                  v-model="form.bonusPenalty"
                  maxlength="500"
                  show-word-limit
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-form>
          </template>
        </el-group-title>
        <!-- <div class="ccui-top-title" style="margin:10px 0;">工作经历</div> -->
      </div>
    </div>

    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
        <div class="ccui-bottom-guide-divider" />
        <li>
          <el-button
            type="bottom"
            icon="icon-ccui-save"
            @click="submitHandle('form')"
            >保存</el-button
          >
        </li>
        <li>
          <el-button
            type="bottom"
            icon="icon-ccui-cancel"
            @click="resetHandle('form')"
            >取消</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
    <el-sorting-selector
      :dialogVisible.sync="dialogVisible"
      :title="Title"
      :staff="staff"
      @deleteStaff="deleteStaff"
      :titleSubtotal="titleSubtotal"
      @gitSelectedStaff="getSelectedStaff"
    >
      <template slot="sortingSelectorTree">
        <el-org-tree
          :autoCode="autoCode"
          :seachData="seachData"
          :showLine="showLine"
          @slectOrgSuccess="slectOrgSuccess"
          @select="handleSelect"
          @leftOrgTree="handleLeftOrgTree"
          :isCache="true"
          ref="tree"
          :expandedKeys="expandedKeys"
          :loadNode="loadNode"
          :defaultKeys="defaultKeys"
          :placeholder="placeholder"
          :fetchSuggestions="searchQuery"
          v-if="leftLevelBelowisShow"
        >
          <template slot-scope="{ item }" slot="up">
            <div :title="item.value" style="display: flex">
              <div :title="item.value" class="orgName">
                <i :class="handleIconClass(item)" class="orgIcon"></i>
                <span style="margin-left: 5px;">{{ item.value }}</span>
              </div>
              <p class="orgFullName">{{ item.abbrName }}</p>
            </div>
          </template>
          <template slot-scope="{ node }" slot="upTree">
            <i
              :class="handleIconClass(node.data, node.level)"
              class="orgIcon"
              style="margin-right:10px;"
            >
            </i>
            <span>{{ node.label }}</span>
            <i class="icon-ccui-check orgIcon" v-show="node.checked"></i>
          </template>
        </el-org-tree>
      </template>
    </el-sorting-selector>
  </div>
</template>
<script>
import {
  getAllprovince,
  getdepartment,
  saveUser,
  getdepartmentSearch
} from "../api/item-list";
import validators from "@/basa/utils/validators";
import { salary, ishasAgentId, getArgs } from "@/basa/utils";
import Cookies from "js-cookie";
export default {
  name: "peoplemanage-tab-new-item",
  data() {
    return {
      title: "新增信息",
      // 上传图片 start
      uploadUrl: this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL),
      loading: false, //上传图片1
      loading1: false, //上传图片2
      imgList: {},
      imgList2: {},
      // 上传图片 end
      fileList: [],
      headers: {
        Authorization: Cookies.get("access_token") || ""
      },
      // access_token: Cookies.get("access_token") || "",
      submitFlag: false,
      isSubmit: true,
      // 选择地址和选择配送区域相关 start
      addressList1: [],
      addressListFinal: [],
      address1: "",
      address2: "",
      addressList2: [],
      addressShow: false,
      url:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/demo/userAndEducation/listAddress",
      leftPlace: "left",
      areaShow: "",
      defaultArea: [],
      // 工作经历
      tableData: [
        {
          id: "1"
        }
      ],
      educationList: [],
      // 工作经历 end
      // 爱好
      hobbyList: [],
      hobbyListArray: [
        {
          value: "篮球",
          label: "1"
        },
        {
          value: "足球",
          label: "2"
        },
        {
          value: "排球",
          label: "3"
        },
        {
          value: "乒乓球",
          label: "4"
        },
        {
          value: "羽毛球",
          label: "5"
        },
        {
          value: "网球",
          label: "6"
        },
        {
          value: "钢琴",
          label: "7"
        },
        {
          value: "舞蹈",
          label: "8"
        },
        {
          value: "绘画",
          label: "9"
        },
        {
          value: "书法",
          label: "10"
        }
      ],
      // 表单
      form: {
        state: 0,
        userName: "",
        sex: "",
        birthday: "",
        age: "",
        politicalOutlook: "",
        isMarried: "",
        nativeplace: "",
        finishSchool: "",
        passportNo: "",
        idNum: "",
        userMobile: "",
        bonusPenalty: "",
        departmentId: [],
        workStatus: "",
        isPrep: 0,
        imageUrl: "",
        imageUrl2: "",
        choseCheck: []
      },
      // 籍贯
      labelName: [],
      valuePlace: [],
      propsPlace: {
        lazy: true,
        lazyLoad(node, resolve) {
          if (node.level === 0) {
            getAllprovince({ code: 0 }).then(response => {
              const cities = response.data.data.map((value, i) => ({
                value: value.code,
                label: value.name,
                leaf: false
              }));
              resolve(cities);
            });
          }
          if (node.level >= 1) {
            getAllprovince({ code: node.value }).then(response => {
              const areas = response.data.data.map((value, i) => ({
                value: value.code,
                label: value.name,
                leaf: !(value.lastFlag === 0)
              }));
              resolve(areas);
            });
          }
        }
      },
      // 籍贯 end
      rules: {
        userName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            validator: validators.userName,
            message: "请输入正确格式的姓名",
            trigger: "change"
          }
        ],
        userMobile: [
          { message: "请输入手机号", trigger: "change" },
          {
            validator: validators.userMobile,
            message: "请输入正确格式的手机号",
            trigger: "change"
          }
        ],
        idNum: [
          {
            validator: validators.identification,
            message: "请输入正确的身份证号码",
            trigger: "change"
          }
        ],
        passportNo: [
          {
            validator: validators.passportNo,
            message: "请输入正确的护照号",
            trigger: "change"
          }
        ],
        salary: [
          {
            validator: validators.money,
            message: "请输入正确金额格式(最多8位整数或8位整数和两位小数)",
            trigger: "change"
          }
        ],
        age: [
          {
            validator: validators.age,
            message: "请输入正确的年龄",
            trigger: "change"
          }
        ]
      },
      // 所在部门相关属性
      nodeItem: [],
      dialogVisible: false,
      showLine: true,
      Title: "选择部门分类",
      titleSubtotal: "已选择部门(0)",
      props: {
        label: "name",
        children: "children"
      },
      autoCode: "",
      placeholder: " 定位查找",
      count: 1,
      seachData: "",
      tableListParam: {},
      param: {
        parentId: "",
        flag: 0 // 展示层级 0 公司 1部门 2 成员
      },
      leftLevelBelowisShow: true,
      leftOrgTreea: "",
      defaultProps: {
        label: "orderName",
        id: "partyId",
        children: "child",
        isLeaf: "isLeaf"
      },
      expandedKeys: [],
      defaultKeys: [],
      staff: [
        // { id: 18, data: { orderName: "三全鲜食17", partyId: 18 } }
      ],
      expandedKey: [],
      selectorList: [],
      restaurants: "",
      // 所在部门相关属性 end
      paramsData: getArgs("a")
    };
  },
  watch: {},
  // computed: {
  //   paramsData: function() {
  //     getArgs('a')
  //   }
  // },
  created() {
    // 所在部门请求
    this.getdepartment();
  },
  mounted() {
    this.restaurants = this.loadAll();
    this.selectDefaultAdress();
  },
  methods: {
    // 选择地址2
    selectDefaultAdress() {
      let IPCodeList = Cookies.get("IPCodeList");
      if (IPCodeList) {
        this.defaultArea = JSON.parse(IPCodeList);
      } else {
        this.defaultArea = [
          {
            name: "北京",
            code: 1
          },
          {
            name: "朝阳区",
            code: 72
          },
          {
            name: "三环以内",
            code: 2799
          }
        ];
      }
      let code = [];
      let name = [];
      this.defaultArea.forEach(i => {
        code.push(i.code);
        name.push(i.name);
      });
      this.addressList2.push(code.join("-"), name.join("-"));
    },
    // handleAxios(infos, index) {
    //   let formData = new FormData();
    //   formData.append("agentId", this.paramsData); // 额外参数
    //   formData.append("file", infos.file);
    //   uploadImg(formData).then(res => {
    //     console.log(res);
    //     if (index == 1) {
    //       this.form.imageUrl = res.data.data[0].downloadUrl;
    //       this.imgList = {
    //         frontId: res.data.data[0].uploadId,
    //         frontUrl: this.form.imageUrl,
    //         frontName: res.data.data[0].fileName
    //       };
    //     } else {
    //       this.form.imageUrl2 = res.data.data[0].downloadUrl;
    //       console.log(this.form.imageUrl2);
    //       this.imgList2 = {
    //         backId: res.data.data[0].uploadId,
    //         backUrl: this.form.imageUrl2,
    //         backName: res.data.data[0].fileName
    //       };
    //     }
    //   });
    // },
    // 所在部门请求
    getdepartment() {
      getdepartment({ flag: 1 }).then(res => {
        console.log(res);
        res.data.data.forEach(item => {
          this.selectorList.push(item);
        });
      });
    },
    // 籍贯相关方法
    // 更改籍贯
    handleChange(value) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.getLabelValue();
        });
      }, 100);
    },
    getLabelValue() {
      if (this.$refs["myCascader"].inputValue) {
        this.labelName = this.$refs["myCascader"].inputValue.split(" / ");
        let labelNameCode = this.$refs["myCascader"].value;
        this.form.receiveProvince = this.labelName[0] || 0;
        this.form.receiveCity = this.labelName[1] || 0;
        this.form.receiveCounty = this.labelName[2] || 0;
        this.form.receiveTowns = this.labelName[3] || 0;
        this.form.receiveProvinceCode = labelNameCode[0] || 0; // 省
        this.form.receiveCityCode = labelNameCode[1] || 0; // 市
        this.form.receiveCountyCode = labelNameCode[2] || 0; // 县
        this.form.receiveTownsCode = labelNameCode[3] || 0; // 乡
      }
    },
    // 籍贯相关方法  end
    // 清空输入框(重置取消)
    resetHandle(formName) {
      for (let i = 1; i < 5; i++) {
        this.$refs[formName + i].resetFields();
      }
      this.form = {
        state: "1",
        isPrep: 0,
        createUserId: []
      };
      this.valuePlace = "";
      this.addressList1 = [];
      this.hobbyList = [];
      this.tableData = [
        {
          id: 1
        }
      ];
    },
    // 保存校验
    submitHandle(formName) {
      if (this.isSubmit == true) {
        let isValid = true;
        for (let i = 1; i < 5; i++) {
          this.$refs[formName + i].validate(valid => {
            if (!valid) {
              isValid = false;
              return false;
            }
          });
          if (!isValid) {
            break;
          }
        }
        if (isValid) {
          this.addPeople();
        } else {
          this.errorLocation(this);
        }
      }
    },
    // 新增保存请求
    addPeople() {
      if (this.tableData) {
        this.tableData.forEach(item => {
          this.educationList.push({
            startTime: item.value1 ? item.value1[0] : "",
            endTime: item.value1 ? item.value1[1] : "",
            company: item.company,
            position: item.position,
            occupation: item.occupation,
            salary: item.salary
          });
        });
      }
      this.form.departmentId = [];
      this.form.choseCheck.forEach(item => {
        this.form.departmentId.push({
          autoCode: item.autoCode,
          abbrName: item.abbrName
        });
      });
      this.addressListFinal = [];
      if (this.addressList1) {
        this.addressList1.forEach(i => {
          this.addressListFinal.push({
            pcode2: i.pcode2,
            cityName: i.cityName ? i.cityName : i.name ? i.name : "",
            code: i.code,
            pcode: i.pcode
          });
        });
      }
      const obj = {
        userName: this.form.userName ? this.form.userName.trim() : undefined,
        sex: this.form.sex ? Number(this.form.sex) : "",
        birthday: this.form.birthday, // 日期类型不用trim
        age: this.form.age ? Number(this.form.age) : undefined,
        receiveProvince: this.form.receiveProvince
          ? this.form.receiveProvince
          : undefined,
        receiveProvinceCode: this.form.receiveProvinceCode
          ? this.form.receiveProvinceCode
          : undefined,
        receiveCity: this.form.receiveCity ? this.form.receiveCity : undefined,
        receiveCityCode: this.form.receiveCityCode
          ? this.form.receiveCityCode
          : undefined,
        receiveCounty: this.form.receiveCounty
          ? this.form.receiveCounty
          : undefined,
        receiveCountyCode: this.form.receiveCountyCode
          ? this.form.receiveCountyCode
          : undefined,
        receiveTowns: this.form.receiveTowns
          ? this.form.receiveTowns
          : undefined,
        receiveTownsCode: this.form.receiveTownsCode
          ? this.form.receiveTownsCode
          : undefined,
        politicalOutlook: this.form.politicalOutlook
          ? Number(this.form.politicalOutlook)
          : "",
        isMarried: this.form.isMarried
          ? Number(this.form.isMarried)
          : undefined,
        finishSchool: this.form.finishSchool
          ? this.form.finishSchool
          : undefined,
        passportNo: this.form.passportNo ? this.form.passportNo : undefined,
        idNum: this.form.idNum ? this.form.idNum : undefined,
        userMobile: this.form.userMobile
          ? this.form.userMobile.trim()
          : undefined,
        hobby: this.hobbyList.length ? this.hobbyList.join(",").trim() : "",
        departmentId:
          this.form.departmentId.length > 0
            ? JSON.stringify(this.form.departmentId)
            : undefined,
        isPrep: Number(this.form.isPrep),
        workStatus: this.form.workStatus ? Number(this.form.workStatus) : "",
        bonusPenalty: this.form.bonusPenalty
          ? this.form.bonusPenalty
          : undefined,
        educationList: this.educationList ? this.educationList : "",
        frontId: this.imgList.frontId ? this.imgList.frontId : "",
        frontUrl: this.imgList.frontUrl ? this.imgList.frontUrl : "",
        frontName: this.imgList.frontName ? this.imgList.frontName : "",
        backId: this.imgList2.backId ? this.imgList2.backId : "",
        backUrl: this.imgList2.backUrl ? this.imgList2.backUrl : "",
        backName: this.imgList2.backName ? this.imgList2.backName : "",
        address1: this.addressListFinal
          ? JSON.stringify(this.addressListFinal)
          : "",
        address2: this.addressList2 ? this.addressList2.join(",") : "",
        isShowLoading: true,
        loadingMessage: "保存中,请稍等..."
      };
      saveUser(obj)
        .then(res => {
          let { code, message } = res.data;
          this.$message({
            message: message,
            type: code === "0" ? "success" : "error",
            // duration: code === "0" ? 3000 : '',
            showClose: true,
            ccuiCustom: true
          });
          this.form = {
            state: 0,
            userName: "",
            sex: "",
            age: "",
            nation: "",
            weight: "",
            // phone: "",
            politicalOutlook: "",
            isMarried: "",
            finishSchool: "",
            passportNo: "",
            idNum: "",
            userMobile: "",
            bonusPenalty: "",
            isPrep: 0,
            departmentId: [],
            choseCheck: []
          };
          this.tableData = [
            {
              id: "1"
            }
          ];
          this.hobbyList = [];
          this.imgList = [];
          this.imgList2 = [];
          if (code === "0") {
            this.submitFlag = true;
            this.handleBack();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    // 返回
    handleBack() {
      this.$router.push(
        sessionStorage.getItem("fromPath") ||
          "/list-query/peoplemanage/item-list-all"
      );
    },
    // 工作经历相关
    // 新增
    addTable() {
      this.tableData.push({
        id: this.tableData.length + 1
      });
    },
    // 删除
    delTable(index, row) {
      this.tableData.splice(index, 1);
    },
    // 工作经历中薪资校验
    handleSalary(event) {
      if (salary(event.target.value) === false) {
        this.$message({
          message: "请输入正确金额格式(最多8位整数或8位整数和两位小数)",
          type: "error",
          // duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        this.isSubmit = false;
        return;
      } else {
        this.isSubmit = true;
      }
    },
    // 工作经历相关 end
    // 所在单位方法
    handleShows() {
      this.dialogVisible = true;
    },
    getSelectedStaff(data) {
      this.form.choseCheck = [];
      data.forEach(item => {
        this.form.choseCheck.push(item.data);
      });
      this.form.choseCheck.forEach(i => {
        if (i.autoCode.indexOf("-") > -1) {
          this.expandedKeys = [];
          this.defaultKeys = [];
          i.autoCode = i.autoCode.split("-");
          i.autoCode.forEach((h, index) => {
            if (h == "") {
              i.autoCode.splice(index, 1);
            }
          });
          let autoCode = i.autoCode.slice(0, i.autoCode.length - 1);
          autoCode.forEach(i => {
            this.expandedKeys.push(i);
          });
          let autoCode1 = i.autoCode.slice(
            i.autoCode.length - 1,
            i.autoCode.length
          );
          autoCode1.forEach(i => {
            this.defaultKeys.push(i);
          });
        }
      });
      this.expandedKeys = [...new Set(this.expandedKeys)];
      this.defaultKeys = [...new Set(this.defaultKeys)];
    },
    deleteStaff(data) {
      this.leftOrgTreea.setChecked(data.data.partyId, false);
      this.staff.splice(0, 1);
      this.titleSubtotal = `已选择部门(${this.staff.length})`;
    },
    handleLeftOrgTree(data) {
      this.leftOrgTreea = data;
    },
    handleIconClass(i, w) {
      // let arr = [
      //   "icon-ccui-organization",
      //   "icon-ccui-unit",
      //   "icon-ccui-man-hollow",
      //   "icon-ccui-woman-hollow"
      // ];
      let keyClass = "";
      if (w === 3 || w === 4) {
        keyClass = "icon-ccui-unit";
      } else {
        keyClass = "icon-ccui-organization";
      }
      let obj = {};
      obj[keyClass] = true;
      return obj;
    },
    slectOrgSuccess(obj, node, tree) {
      // if (node.level === 3 || node.level === 4) {
      //   this.$set(node, "checked", true);
      //   this.staff.push(node);
      //   let obj = {};
      //   this.staff = this.staff.reduce(function(item, next) {
      //     obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
      //     return item;
      //   }, []);
      //   this.titleSubtotal = `已选择部门(${this.staff.length})`;
      // }
      // if (this.staff.length > 3) {
      //   this.$message({
      //     message: "最多选择3个部门",
      //     type: "error",
      //     duration: 3000,
      //     showClose: true,
      //     ccuiCustom: true
      //   });
      //   this.staff.splice(this.staff.length - 1, 1);
      // }

      //单选
      if (node.level === 4 || node.level === 3) {
        this.$set(node, "checked", true);
        console.log(this.nodeItem);
        this.$set(this.nodeItem, "checked", false);
        console.log(node.checked);
        if (node.checked === true) {
          this.leftOrgTreea.setCheckedKeys([obj.partyId]);
          console.log(this.leftOrgTreea.getCheckedNodes());
        }
        let objadd = this.leftOrgTreea.getCheckedNodes();
        console.log(objadd);
        let add = [
          {
            data: objadd[objadd.length - 1]
          }
        ];

        this.staff = add;
        this.titleSubtotal = `已选择部门(${this.staff.length})`;
      }
      if (obj.partyId) {
        this.tableListParam.partyId = obj.partyId;
      }
      this.nodeItem = node;
      // if (obj.id) {
      //   this.tableListParam.id = Number(obj.id);
      //   // sessionStorage.id = JSON.stringify(this.tableListParam.id);
      //   if (this.$refs.selectTabs) {
      //     // this.$refs.selectTabs.getDataList(JSON.parse(sessionStorage.id), obj);
      //   }
      // }
      // if (obj.isLeaf) {
      //   // sessionStorage.isLeaf = this.tableListParam.isLeaf;
      // }
    },
    handleSelect(item) {
      this.expandedKeys = item.autoCode.split("-");
      // getdepartmentSearch({
      //   branchName:ite
      //   flag:0,m.abbrName
      // }).then(res=>{
      //   console.log(res);
      //   // cb(res.data.data.rows);
      // })
      this.leftLevelBelowisShow = false;
      this.$nextTick(() => {
        // this.autoCode = item.autoCode;
        // this.param.partyId = item.partyId;
        this.leftLevelBelowisShow = true;
      });
    },
    searchQuery(queryString, cb) {
      getdepartmentSearch({
        flag: 0,
        branchName: ""
      }).then(res => {
        cb(res.data.data.rows);
      });
      // var restaurants = this.restaurants;
      // var results = queryString
      //   ? restaurants.filter(this.createFilter(queryString))
      //   : restaurants;
      // // 调用 callback 返回建议列表的数据
      // cb(results);
      // if (sessionStorage.oldSeachData === queryString) {
      //   cb(this.resultJsonParse(sessionStorage.seachResult));
      // } else {
      //   let restaurants = this.restaurants;
      //   sessionStorage.seachResult = restaurants;
      //   cb(restaurants);
      // }
    },
    // resultJsonParse(string) {
    //   return JSON.parse(string);
    // },
    loadAll() {
      // getdepartmentSearch({
      //   flag:3,
      //   branchName:''
      // }).then(res=>{
      //   console.log(res);
      //   return res.data.data.row
      // })
    },
    renderContent(h, { node, data, store }) {
      let isUserHtml;
      if (node.level === 3) {
        data.isShowIcon = false;
        isUserHtml = (
          <i
            style="color:#0089EF;font-size:14px;position:absolute;right: 0;"
            class="icon-ccui-check"
          ></i>
        );
      }
      if (data.orgType === "2") {
        isUserHtml = (
          <i
            v-if="data.isShowIcon"
            class="icon-ccui-user is-leaf-user"
            style="color:#0089EF;font-size:14px;"
          ></i>
        );
      }
      return (
        <span style="display:flex;align-items:center;padding-right: 8px;">
          {isUserHtml}
          <span style="font-size: 13px; margin-left:6px">{node.label}</span>
        </span>
      );
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve(this.selectorList);
      }
      if (node.level > 3) return resolve([]);

      let hasChild;
      if (node.data.partyId === 1) {
        hasChild = true;
      } else {
        hasChild = Math.random() * 5115 > 30;
      }
      setTimeout(() => {
        let data = [];
        if (hasChild) {
          this.selectorList.forEach(item => {
            data = item.child;
          });
        } else {
          data = [];
        }
        resolve(data);
      }, 500);
    },
    deleteClass(index) {
      this.form.choseCheck.splice(index, 1);
      this.staff.splice(index, 1);
      this.expandedKeys = [];
      this.defaultKeys = [];
      this.form.choseCheck.forEach(i => {
        let autoCode = i.autoCode.slice(0, i.autoCode.length - 1);
        autoCode.forEach(i => {
          this.expandedKeys.push(i);
        });
        let autoCode1 = i.autoCode.slice(
          i.autoCode.length - 1,
          i.autoCode.length
        );
        autoCode1.forEach(i => {
          this.defaultKeys.push(i);
        });
      });
      this.expandedKeys = [...new Set(this.expandedKeys)];
      this.defaultKeys = [...new Set(this.defaultKeys)];
    },
    // 所在单位相关方法 end
    // 上传图片
    handleSuccess(res) {
      this.form.imageUrl = res.data[0].downloadUrl;
      this.imgList = {
        frontId: res.data[0].uploadId,
        frontUrl: this.form.imageUrl,
        frontName: res.data[0].fileName
      };
      this.loading = false;
    },
    handleSuccess1(res) {
      this.form.imageUrl2 = res.data[0].downloadUrl;
      this.imgList2 = {
        backId: res.data[0].uploadId,
        backUrl: this.form.imageUrl2,
        backName: res.data[0].fileName
      };
      this.loading1 = false;
    },
    handleError(res) {
      this.loading = false;
    },
    handleError1(res) {
      this.loading1 = false;
    },
    uploadBeforeAvatar(file) {
      this.loading = true;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.loading = false;
        this.$message({
          message: "上传图片只能是 JPG/PNG 格式!",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
      if (!isLt2M) {
        this.loading = false;
        this.$message({
          message: "上传图片大小不能超过 2MB!",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }

      return isJPG && isLt2M;
    },
    uploadBeforeAvatar1(file) {
      this.loading1 = true;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.loading1 = false;
        this.$message({
          message: "上传图片只能是 JPG/PNG 格式!",
          type: "error",
          // duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
      if (!isLt2M) {
        this.loading1 = false;
        this.$message({
          message: "上传图片大小不能超过 2MB!",
          type: "error",
          // duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }

      return isJPG && isLt2M;
    },
    // 上传图片 end
    // 选择地址
    selectAddress1() {
      this.addressShow = true;
    },
    // 选择配送区域
    getMyCancel(cityValue) {
      if (cityValue.length === 1) {
        if (cityValue[0].cityName == "全国") {
          this.addressList1 = [];
          return;
        }
      } else {
        cityValue = cityValue.filter(item => {
          return item.pcode2 != "全国";
        });
      }
      this.addressList1 = cityValue;
    },
    // 选择地址2
    getAddressOf(cityValue) {
      this.addressList2 = [];
      let pcode = [],
        cityName = [];
      cityValue.forEach(i => {
        pcode.push(i.code);
        cityName.push(i.name);
      });
      this.addressList2.push(pcode.join("-"), cityName.join("-"));
      Cookies.set("IPCodeList", cityValue, { domain: ".iccec.cn" });
    }
  },
  // 更改列表缓存状态
  beforeRouteLeave(to, from, next) {
    if (this.submitFlag === true) {
      for (var key in this.$vnode.parent.parent.componentInstance.cache) {
        delete this.$vnode.parent.parent.componentInstance.cache[
          ishasAgentId(to.path, key)
        ];
      }
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    !(to.fullPath === from.fullPath) &&
      sessionStorage.setItem("fromPath", from.fullPath);
    next();
  }
};
</script>
